import { SERIA_PLUS_V3_IMAGE_BASE_URL, createDescription, createSlideMarkers, createTab } from './utils';

const terraceDescription = createDescription([
  'Наслаждайтесь ужинами под открытым небом, работайте',
  'удалённо с видом на город или просто отдыхайте, любуясь',
  'окружающим пейзажем.',
]);

export const terracesTab = createTab({
  slides: [
    {
      ...terraceDescription,
      imageAlt: 'Терраса с ограждением из стекла в квартале Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/terraces/1.webp`,
      markers: createSlideMarkers([
        {
          left: 1260,
          tooltip: { placement: 'top', text: 'Электричество' },
          top: 680,
        },
        {
          left: 1432,
          tooltip: { placement: 'top', text: 'Ограждение из многослойного безопасного стекла' },
          top: 682,
        },
        {
          left: 1200,
          tooltip: { placement: 'right', text: 'Гидроизоляция пола' },
          top: 748,
        },
        {
          left: 800,
          tooltip: { placement: 'right', text: 'Водосток' },
          top: 770,
        },
      ]),
    },
    {
      ...terraceDescription,
      imageAlt: 'Просторная терраса в квартале Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/terraces/2.webp`,
      markers: createSlideMarkers([
        {
          left: 632,
          tooltip: { placement: 'right', text: 'Терраса с видом на воду' },
          top: 614,
        },
      ]),
    },
    {
      ...terraceDescription,
      imageAlt: 'Терраса с видом на город в квартале Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/terraces/3.webp`,
      markers: createSlideMarkers([
        {
          left: 1137,
          tooltip: { placement: 'right', text: 'Терраса с видом на лес' },
          top: 661,
        },
      ]),
    },
    {
      ...terraceDescription,
      imageAlt: 'Открытая терраса в квартале Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/terraces/4.webp`,
    },
  ],
  title: 'Террасы',
});
